var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.716,
    height: 16.484,
    viewBox: "0 0 19.716 16.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27",
    d: "M18 9h9.858v1.408H18z",
    transform: "translate(-8.142 -6.183)",
    style: {
      fill: "#1e0058"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28",
    d: "M5.067 9.141 3.243 7.317l-.993.993 2.817 2.817L10.7 5.493 9.707 4.5z",
    transform: "translate(-2.25 -4.5)",
    style: {
      fill: "#1e0058"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29",
    d: "M18 24.75h9.858v1.408H18z",
    transform: "translate(-8.142 -12.075)",
    style: {
      fill: "#1e0058"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 30",
    d: "m5.067 24.891-1.824-1.824-.993.993 2.817 2.817 5.633-5.634-.993-.993z",
    transform: "translate(-2.25 -10.392)",
    style: {
      fill: "#1e0058"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListChecked);
export default __webpack_public_path__ + "static/media/list-checked.dfc3a3a37558f9455e3a6dfa7ed92e42.svg";
export { ForwardRef as ReactComponent };